module.exports = __webpack_public_path__ + "img/8.a3f288f9.jpg";